import { ExternalLink } from 'lucide-react'

import { formatDate } from '../../../../lib/formatters'
import { formatCurrency } from '../../../../lib/utils'
import { CoverageCancellationStatus, type InsuranceCoverage } from '../../../../models/insuranceTypes'

/** One coverage line inside a policy card: label + premium, with its limits below. */
export function PolicyCoverageRow({ coverage }: { coverage: InsuranceCoverage }) {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-md flex items-baseline justify-between gap-4">
        <span className="font-semibold text-black">{coverage.label}</span>
        <span className="font-semibold text-black">{formatCurrency(coverage.premium)}</span>
      </div>
      <div className="text-muted-foreground text-md flex flex-wrap gap-x-4 font-medium">
        {coverage.limit != null && <span>Limit per claim {formatCurrency(coverage.limit)}</span>}
        {coverage.deductible != null && (
          <span>
            {coverage.comprehensiveDeductible != null ? 'Collision deductible' : 'Deductible'}{' '}
            {formatCurrency(coverage.deductible)}
          </span>
        )}
        {coverage.comprehensiveDeductible != null && (
          <span>Comprehensive deductible {formatCurrency(coverage.comprehensiveDeductible)}</span>
        )}
        {coverage.vendorPolicyId &&
          (coverage.vendorPolicyUrl ? (
            <a
              className="inline-flex items-center gap-1 underline"
              href={coverage.vendorPolicyUrl}
              target="_blank"
              rel="noreferrer"
            >
              Policy {coverage.vendorPolicyId} <ExternalLink className="size-3" />
            </a>
          ) : (
            <span>Policy {coverage.vendorPolicyId}</span>
          ))}
      </div>
      {coverage.cancellationStatus === CoverageCancellationStatus.CANCELING && (
        <span className="text-warning-d1 text-md font-medium">
          Cancels on {formatDate(coverage.dateCanceled)}
        </span>
      )}
      {coverage.cancellationStatus === CoverageCancellationStatus.CANCELED && (
        <span className="text-error text-md font-medium">
          Canceled as of {formatDate(coverage.dateCanceled)}
        </span>
      )}
    </div>
  )
}
